import { SoftMpiSculpt } from '../components/SoftMpiSculpt.js';

/**
 * POC harness for the soft-MPI renderer (read-only, param-driven, like
 * /spatial2-test). Query params:
 *   ?src=http://localhost:8000/out/gen_x-0/softmpi   — soft-MPI asset dir base
 *        (meta.json + plane_NN.png); cover defaults to <src>/../cover.png but
 *        the plane_00 (opaque bg) already carries the whole painting.
 *   &cover=<url>   — explicit cover for the fallback <img>
 *   &aspect=1.5    — gilding aspect (w/h)
 *   &ambient=0     — idle/pointer drive instead of the auto-orbit
 *   &still=1       — pin the exact rest pose (window.__sculptStill)
 * Deterministic pose: window.__sculptPose = {sx,sy} (set by Playwright).
 */
export function SoftMpiTest() {
  const params = new URLSearchParams(window.location.search);
  const base = params.get('src');
  const aspect = parseFloat(params.get('aspect') ?? '1');
  const ambient = params.get('ambient') !== '0';
  if (params.get('still') === '1') {
    (window as unknown as { __sculptStill?: boolean }).__sculptStill = true;
  }
  const cover = params.get('cover') ?? (base ? `${base}/rest_preview.png` : null);
  if (!base || !cover) {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#0a0810', color: '#c9c2d6', fontFamily: 'monospace', padding: '2rem' }}>
        <pre>{'softmpi-test usage:\n  ?src=<softmpi asset dir base>[&cover=<url>][&aspect=1][&ambient=0][&still=1]'}</pre>
      </div>
    );
  }
  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#0a0810' }}>
      <SoftMpiSculpt src={cover} base={base} aspect={aspect} ambient={ambient} heightCap="86svh" />
    </div>
  );
}
